// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, object, string } from 'prop-types'
import { connect } from 'react-redux'
import MultiSelect from './MultiSelect'

class MultiSelectFromState extends React.Component {
  static propTypes = {
    disabled: bool,
    id: string,
    input: object.isRequired,
    label: string,
    labelKey: string.isRequired,
    options: object.isRequired,
    targetSet: array.isRequired,
    valueKey: string.isRequired,
  }

  state = {
    options: [],
  }

  componentWillMount () {
    const {
      labelKey,
      options,
      valueKey,
    } = this.props

    // clean the options so handling them on selecting and in form submission is cleaner.
    // NOTE - this strips all values which are not labelKey, valueKey
    const cleanedOptions = options.reduce((a, d, i) => {
      a.push({
        [labelKey]: d.get(labelKey),
        [valueKey]: d.get(valueKey),
      })
      return a
    }, [])

    this.setState(() => ({
      options: cleanedOptions,
    }))
  }

  render () {
    const {
      disabled,
      id,
      input,
      label,
      labelKey,
      valueKey,
    } = this.props

    return (
      <MultiSelect
        disabled={disabled}
        id={id}
        input={input}
        label={label}
        labelKey={labelKey}
        options={this.state.options}
        valueKey={valueKey} />
    )
  }
}

const mapStateToProps = ({ domain }, { targetSet }) => ({
  options: domain.getIn(targetSet),
})

export default connect(
  mapStateToProps,
)(MultiSelectFromState)
